import classNames from "classnames";

import { CompositionSection as CompositionSectionInterface } from "@/api/generatedTypes";

import styles from "./CompositionSection.module.scss";

interface CompositionSectionProps {
  composition: string | CompositionSectionInterface[] | undefined;
  className?: string;
}

const CompositionSection = ({
  composition,
  className,
}: CompositionSectionProps) => {
  if (typeof composition === "string") {
    return (
      <div className={classNames(styles.root, className)}>
        <p className={styles.title}>Состав</p>
        <p className={styles.text}>{clearTags(composition)}</p>
      </div>
    );
  }

  if (Array.isArray(composition)) {
    return (
      <div className={(styles.structuredComposition, className)}>
        {composition.map((compositionItem) => (
          <div className={styles.compositionItem} key={compositionItem.id}>
            <p className={styles.compositionHeader}>{compositionItem.name}</p>
            <div className={styles.compositionContainer}>
              {compositionItem.items.map((item) => (
                <div key={item.id} className={styles.materialItem}>
                  <p className={styles.title}>{item.material}</p>
                  <p className={styles.percentage}>{item.value}%</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return null;
};

export const clearTags = (value: string) => {
  if (!value) return;
  return value.replaceAll(/<p>|<\/p>/g, "");
};

export default CompositionSection;
